/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_Am_RoiInputs */

const vi_shop_product_type_am_roi = /** @type {(inputs: Shop_Product_Type_Am_RoiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ấm rời / Rời`)
};

/**

* @param {Shop_Product_Type_Am_RoiInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_am_roi = /** @type {((inputs?: Shop_Product_Type_Am_RoiInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_Am_RoiInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_am_roi(inputs)
});